import RecordVoiceOverOutlinedIcon from "@mui/icons-material/RecordVoiceOverOutlined";
import { MenuItem, Snackbar, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect, useState } from "react";
import InterviewRecordingUploader from '../../components/discovery/interview/InterviewRecordingUploader';
import { baseAtom, getTopOfSnackbarQueue } from '../../stores/jotai/base';
import { fileUploadAtom, setUppyInstance } from '../../stores/jotai/fileUpload';

export default function CustomNavigationAndUploadsHandler(props) {
    const theme = useTheme();
    if (props?.justRenderMenu === true) {
        const onUploadButtonClick = () => {
            try {
                document.getElementById("recording-upload")?.click();
            } catch (e) { }
        }

        return (
            <>
                <MenuItem
                    id="joy-app-uploads"
                    onClick={() => {
                        onUploadButtonClick();
                    }}
                >
                    <RecordVoiceOverOutlinedIcon
                        sx={{ marginRight: "8px", color: theme?.custom?.mainIconColor }}
                    />{" "}
                    Create Interview(s) from Audio/Video upload
                </MenuItem>
            </>
        );
    }

    const { onInterviewModalClose } = props;
    const [base, setBase] = useAtom(baseAtom);
    const setFileUploadAtomState = useSetAtom(fileUploadAtom);
    const [s, setS] = useState(false);
    const [currentSnackbar, setCurrentSnackbar] = useState(undefined);

    const hasAnyProgress = () => {
        try {
            const files = base?.uppyFiles;

            let hasAny = false;

            for (let i = 0; i < files?.length; i++) {
                if (files[i]?.progress?.uploadComplete === false) {
                    hasAny = true;
                }
            }

            return hasAny;
        }
        catch (e) {
            return false;
        }
    }

    useEffect(() => {
        try {
            window.onbeforeunload = function () {
                if (hasAnyProgress()) {
                    return "Are you sure you want to navigate away while you are uploading interviews?";
                }
            };
        } catch (e) {}
    }, []);

    useEffect(() => {
        if (base) {
            if (base?.snackbarQueue) {
                if (base.snackbarQueue?.length > 0) {
                    if (s === false) {
                        if (currentSnackbar === undefined) {
                            getTopOfSnackbarQueue(setBase, (e) => {
                                if (e !== undefined) {
                                    setTimeout(() => {
                                        setCurrentSnackbar(e);
                                        setS(false);
                                    }, 300);
                                    setS(true);
                                }
                            });
                        }
                    }
                }
            }
        }
    }, [base, s, currentSnackbar]);

    return (
        <div>
            <Snackbar
                open={currentSnackbar !== undefined}
                autoHideDuration={6000}
                onClose={() => {
                    setCurrentSnackbar(undefined);
                }}
                message={
                    <Stack>
                        <Typography>{currentSnackbar?.title}</Typography>
                        <Typography>{currentSnackbar?.content}</Typography>
                    </Stack>
                }
                action={<div></div>}
            />
            <InterviewRecordingUploader
                primaryInstance={true}
                hideImportButton={true}
                onUppyInitialization={(uppyInstance) =>
                    setUppyInstance(setFileUploadAtomState, uppyInstance)
                }
                onInterviewModalClose={onInterviewModalClose}
            />
        </div>
    );
}
